const Publications = [
    {
        topic: 'Prevalence of seven potential urethritis-causing pathogens and factors associated with urethritis symptoms reporting in individuals at high-risk of HIV acquisition in Chiang Mai, Thailand. ',
        author: 'Thant YM, Salvadori N, Khamduang W, Arunothong S, Hongjaisee S, Wantanajittikul K, Pornprasert S, Akarasereenont T, Promnites P, Boontan C, Piriya C, Chalermpantmetagul S, Chairahaeng S, Piyarad S, Ongwandee S, Jourdain G, Ngo-Giang-Huong N. ',
        publish: 'Published online: 9 Feb 2026',
        year: 2026,
        book: 'SSRN 2026. ',
        link: 'http://dx.doi.org/10.2139/ssrn.6110900',
        date: '2026-02-09'
    },
    {
        topic: 'Colorimetric loop-mediated isothermal amplification for the rapid and visual detection of hepatitis B virus.',
        author: 'Khan SJ, Khamai L, Kham-Kjing N, Khamduang W, Hongjaisee S.',
        publish: 'Published online: 11 Jan 2026',
        year: 2026,
        book: 'Scientific Report.',
        link: 'https://doi.org/10.1038/s41598-026-35503-8',
        date: '2026-01-11'
    },
    {
        topic: 'Household SARS-CoV-2 transmission during Omicron wave in Chiang Mai, Thailand: a prospective observational study',
        author: 'Woottichai Khamduang, Pitaya Suebtam, Intira Jeannie Collins, Patumrat Sripan, Kittipan Chalom, Sayamon Hongjaisee, Nang Kham-Kjing, Nantawan Wangsaeng, Premmarin Inmonthian, Aphirak Pinasu, Napatsakorn Kohklang, Mathis Arnal, Moira Spyer, Ilse Steffens-Westerhof, Apinun Aramrattana, Marc Lallemant, Chaisiri Angkurawaranon, Patricia Bruijning-Verhagen, and Nicole Ngo-Giang-Huong, for the Thailand VERDI-RECOVER study team',
        publish: 'Published online: Jan 2026',
        year: 2026,
        book: 'The Lancet Regional Health - Southeast Asia',
        link: 'https://doi.org/10.1016/j.lansea.2025.100711',
        date: '2026-01'
    },
    {
        topic: 'Etiology of severe acute respiratory infections among adults in northern Thailand using multiplex PCR: a post-COVID-19 surveillance study (2023–2024).',
        author: 'Kham-Kjing N, Kawila R, Tariyo P, Puapun K, Wongchotbrorirak S, Ngo-Giang-Huong N, Hongjaisee S, Khamduang W.',
        publish: 'Published online: 2026',
        year: 2026,
        book: 'PLoSOne 2026. (Second Revision)',
        link: '',
        date: ''
    },
    {
        topic: 'Comprehensive pathogen profiling in adult patients with severe acute respiratory infections using metagenomic Next-Generation Sequencing of sputum samples.',
        author: 'Kham-Kjing N, Kawila R, Tariyo P, Puapun K, Ngo-Giang-Huong N, Hongjaisee S, Khamduang W.',
        publish: 'Published online: 15 Dec 2025',
        year: 2025,
        book: 'medRxiv.',
        link: 'https://doi.org/10.64898/2025.12.12.25342137',
        date: '2025-12-15'
    },
    {
        topic: 'Sputum respiratory pathogen genomic surveillance: a practical approach for long-read metagenomic sequencing.',
        author: 'Kham-Kjing N, Ngo-Giang-Huong N, Khamduang W.',
        publish: 'Published online: 08 Dec 2025',
        year: 2025,
        book: 'bioRxiv.',
        link: 'https://doi.org/10.64898/2025.12.08.692896',
        date: '2025-12-08'
    },
    {
        topic: 'Assessment of seroprevalence of Mpox virus infection among sex workers in Chiang Mai, Thailand',
        author: 'Umer M, Chawansuntati K, Wipasa J, Jindaphun K, Kotemul K, Thant YM, Ngo-Giang-Huong N, Khamduang W, Hongjaisee S. ',
        publish: 'Published online: Nov 2025;160:108041.',
        year: 2025,
        book: 'Int J Infect Dis.',
        link: 'https://doi.org/10.1016/j.ijid.2025.108041',
        date: '2025-11'
    },
    {
        topic: 'Biomarker changes before and after the 2024 peak burning period in healthy, diabetic, and hypertensive residents of Chiang Mai, Thailand.',
        author: 'Xianfeng C, Yadoung S, Tongchai P, Pata S, Khamduang W, Chawansuntati K, Yodkeeree S, Wongta A, Kulprachakarn K, Kosashunhanan N, Hongsibsong S.',
        publish: 'Published online: 13 Oct 2025;13:1535448',
        year: 2025,
        book: 'Front Public Health.',
        link: 'https://doi.org/10.3389/fpubh.2025.1535448',
        date: '2025-10-13'
    },
    {
        topic: 'Vector competence of Aedes albopictus for Tonate virus highlights transmission risks in temperate and tropical regions',
        author: 'Isabelle Moltini-Conclois, Wipaporn Khanom, Elliott F. Miot, Ai-rada Pintong, Hermann Landry Munshili Njifon, Carole Ginebre, Valérie Choumet, Bruno Coutard, Cédric Mariac, Pierre Roques, Agathe M. G. Colmant, Géraldine Piorkowski, Julien Pompon & Dorothée Missé',
        publish: 'Published online: 03 Sep 2025',
        year: 2025,
        book: 'Emerging Microbes & Infections 2025, VOL. 14, 2547733 https://doi.org/10.1080/22221751.2025.2547733',
        link: 'https://www.tandfonline.com/doi/full/10.1080/22221751.2025.2547733',
        date: '2025-09-03'
    },
    {
        topic: 'Molecular Epidemiology of Hepatitis C Virus Genotypes in Northern Thailand: A Retrospective Study from 2016 to 2024',
        author: 'Kham-Kjing N, Phruekthayanon S, Krueyot T, Phutthakham P, Intarasoot S, Trakoolpua K, Preechasuth K, Samleerat-Carraway T, Kongyai N, Khamduang W.',
        publish: 'Published:23 June 2025',
        year: 2025,
        book: 'Infect. Dis. Rep.2025, 17(4), 73',
        link: 'https://doi.org/10.3390/idr17040073',
        date: '2025-06-23'
    },
    {
        topic: 'IFITMs exhibit antiviral activity against Chikungunya and Zika virus infection via the alteration of TLRs and RLRs signaling pathways',
        author: 'Nuttamonpat Gumpangseth, Paola Mariela Saba Villarroel, Abibatou Diack, Thanaphon Songhong, Sakda Yainoy, Rodolphe Hamel, Wipaporn Khanom, Phanit Koomhin, Chuchard Punsawad, Anon Srikiatkhachorn, Dorothée Missé, Phoonthawee Saetear & Sineewanlaya Wichit',
        publish: 'Published: May 2025',
        year: 2025,
        book: 'Sci Rep 15, 15769 (2025). https://doi.org/10.1038/s41598-025-00663-6',
        link: 'https://www.nature.com/articles/s41598-025-00663-6',
        date: '2025-05-06'
    },
    {
        topic: 'The spatiotemporal ecology of Oropouche virus across Latin America: a multidisciplinary, laboratory-based, modelling study',
        author: 'Carlo Fischer, Anna Frühauf, Lucia Inchauste, Murilo Henrique Anzolini Cassiano, Heriberto Arévalo Ramirez, Karine Barthélémy, Dorothée Missé, et al.',
        publish: 'Published: April 2025',
        year: 2025,
        book: 'Lancet Infect Dis (2025). https://doi.org/10.1016/S1473-3099(25)00110-0',
        link: 'https://www.thelancet.com/journals/laninf/article/PIIS1473-3099(25)00110-0/fulltext',
        date: '2025-04-14'
    },
    {
        topic: 'Respiratory health and chronic disease risks in residents of agricultural areas in Chiang Mai, Northern Thailand',
        author: 'Wongta A, Pata S, Chawansuntati K, Yodkeeree S, Hongsibsong S, Khamduang W. ',
        publish: 'Published:04 April 2025',
        year: 2025,
        book: 'PLoS One. 2025 Apr 4;20(4):e0321471.',
        link: 'https://doi.org/10.1371/journal.pone.0321471',
        date: '2025-04-04'
    },
    {
        topic: 'Feasibility assessment of telehealth-based non-communicable disease screening and monitoring by community health leaders in remote areas: A pilot study in Chiang Mai, Thailand.',
        author: 'Kaewkart S, Suebtam P, Thatong S, Kaewkart N, Pinasu A, Inmonthian P, Kohklang N, Wantanajittikul K, Pornprasert S, Shah F, Samleerat-Carraway T, Khamduang W.',
        publish: 'Published:13 March 2025',
        year: 2025,
        book: 'medRxiv',
        link: 'https://doi.org/10.1101/2025.03.11.25323802',
        date: '2025-03-13'
    },
    {
        topic: 'Seroprevalence and associated factors of HIV, syphilis, hepatitis B, and hepatitis C infections among sex workers in Chiangmai, Thailand during easing of COVID-19 lockdown measures',
        author: 'Sayamon Hongjaisee ,Woottichai Khamduang,Nang Kham-Kjing, Nicole Ngo-Giang-Huong, Arunrat Tangmunkongvorakul',
        publish: 'Published: December 2024',
        year: 2024,
        book: 'PLOS ONE 19(12): e0316668 ;https://doi.org/10.1371/journal.pone.0316668',
        link: 'https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0316668',
        date: '2024-12-31'
    },
    {
        topic: 'West Nile virus can be transmitted within mosquito populations through infectious mosquito excreta',
        author: 'Rodolphe Hamel, Quentin Narpon, Idalba Serrato-Pomar, Camille Gauliard, Arnaud Berthomieu, Sineewanlaya Wichit, Dorothée Missé, Mircea T Sofonea, Julien Pompon',
        publish: 'Published:15 November 2024',
        year: 2024,
        book: 'iScience. 2024 Oct 4;27(11):111099. doi: 10.1016/j.isci.2024.111099',
        link: 'https://www.sciencedirect.com/science/article/pii/S2589004224023241?via%3Dihub',
        date: '2024-11-15'
    },
    {
        topic: 'Impact of fine particulate matter (PM2.5) on ocular health among people living in Chiang Mai, Thailand',
        author: 'Kausar S, Tongchai P, Yadoung S, Sabir S, Pata S, Khamduang W, Chawansuntati K, Yodkeeree S, Wongta A, Hongsibsong S.',
        publish: 'Published:03 November 2024',
        year: 2024,
        book: 'Sci Rep. 2024 Nov 3;14(1):26479.',
        link: 'https://doi.org/10.1038/s41598-024-77288-8',
        date: '2024-11-03'
    },
    {
        topic: 'Seroprevalence of SARS-CoV-2 nucleocapsid antibody among sex workers during the 5th epidemic wave with Omicron variant in Chiang Mai, Thailand',
        author: 'Sayamon Hongjaisee, Ratchadakorn Guntala, Arunrat Tangmunkongvorakul , Nicole Ngo-Giang-Huong and Woottichai Khamduang',
        publish: 'Published: August 2024',
        year: 2024,
        book: 'Heliyon Volume 10, Issue 17;https://doi.org/10.1016/j.heliyon.2024.e36807',
        link: 'https://www.sciencedirect.com/science/article/pii/S2405844024128381?via%3Dihub',
        date: '2024-09-15'
    },
    {
        topic: 'Contamination of Streptococcus suis and S. suis Serotype 2 in Raw Pork and Edible Pig Organs: A Public Health Concern in Chiang Mai, Thailand',
        author: 'Ratchadakorn Guntala, Likhitphorn Khamai, Nattawara Srisai, Sakaewan Ounjaijean, Woottichai Khamduang and Sayamon Hongjaisee',
        publish: 'Published: July 2024',
        year: 2024,
        book: 'Foods 2024, 13(13), 2119;https://doi.org/10.3390/foods13132119 (registering DOI)',
        link: 'https://www.mdpi.com/2304-8158/13/13/2119?fbclid=IwZXh0bgNhZW0CMTAAAR12MbTsGzvoCBZkZD1SpjYkCBADydlwa9t1KeZZXdbJiDauOxYlh-AQHTk_aem_PxnmswyJIBY7p35guqmpEg',
        date: '2024-07-03'
    },
    {
        topic: 'Seroprevalence study in humans and molecular detection in Rhipicephalus sanguineus ticks of severe fever with thrombocytopenia syndrome virus in Thailand',
        author: 'Paola Mariela Saba Villarroel, Tanawat Chaiphongpachara, Elif Nurtop, Sedthapong Laojun, Tassanee Pangpoo-nga, Thanaphon Songhong, Dolruethai Supungul, Cécile Baronti, Laurence Thirion, Pornsawan Leaungwutiwong, Xavier de Lamballerie, Dorothée Missé, Sineewanlaya Wichit',
        publish: 'Published: June 2024',
        year: 2024,
        book: 'Scientific Reports volume 14, Article number: 13397 (2024); https://doi.org/10.1038/s41598-024-64242-x',
        link: 'https://www.nature.com/articles/s41598-024-64242-x#citeas',
        date: '2024-06-11'
    },
    {
        topic: 'Global seroprevalence of Zika virus in asymptomatic individuals: A systematic review',
        author: 'Paola Mariela Saba Villarroel,Rodolphe Hamel,Nuttamonpat Gumpangseth,Sakda Yainoy,Phanit Koomhin,Dorothée Missé,Sineewanlaya Wichit',
        publish: 'Published: April 2024',
        year: 2024,
        book: 'PLOS Neglected Tropical Diseases 18, e0011842; https://doi.org/10.1371/journal.pntd.0011842',
        link: 'https://journals.plos.org/plosntds/article?id=10.1371/journal.pntd.0011842',
        date: '2024-04-17'
    },
    {
        topic: 'In-vitro assessment of cutaneous immune responses to aedes mosquito salivary gland extract and dengue virus in Cambodian individuals',
        author: 'David Guerrero, Sokchea Lay, Eakpor Piv, Chansophea Chhin, Sokkeang Leng, Ratana Meng, Kim Eng Mam, Polidy Pean, Amelie Vantaux, Sebastien Boyer, Dorothée Missé, Tineke Cantaert',
        publish: 'Published: April 2024',
        year: 2024,
        book: 'Oxford Open Immunology, Volume 5, Issue 1, 2024, iqae003; https://doi.org/10.1093/oxfimm/iqae003',
        link: 'https://academic.oup.com/ooim/article/5/1/iqae003/7638810',
        date: '2024-04-01'
    },
    {
        topic: 'A Single-Tube Colorimetric Loop-Mediated Isothermal Amplification for Rapid Detection of SARS-CoV-2 RNA',
        author: 'Hongjaisee S, Kham-Kjing N, Musikul P, Daengkaokhew W, Kongson N, Guntala R, Jaiyapan N, Kline E, Panpradist N, Ngo-Giang-Huong N, et al.',
        publish: 'Published: September 2023',
        year: 2023,
        book: 'Diagnostics 2023, 13(19), 3040;https://doi.org/10.3390/diagnostics13193040',
        link: 'https://www.mdpi.com/2075-4418/13/19/3040',
        date: '2023-09-25'
    },
    {
        topic: 'Identification of the Tembusu Virus in Mosquitoes in Northern Thailand',
        author: 'Rodolphe Hamel, Ronald Enrique Morales Vargas, Dora Murielle Rajonhson, Atsushi Yamanaka, Jiraporn Jaroenpool, Sineewanlaya Wichit, Dorothée Missé, Anamika Kritiyakan, Kittipong Chaisiri, Serge Morand, Julien Pompon',
        publish: 'Published: June 2023',
        year: 2023,
        book: 'Viruses. 2023 Jun 27;15(7):1447. doi: 10.3390/v15071447',
        link: 'https://www.mdpi.com/1999-4915/15/7/1447',
        date: '2023-06-27'
    },
    {
        topic: 'Emerging and re-emerging zoonotic viral diseases in Southeast Asia: One Health challenge',
        author: 'Saba Villarroel Paola Mariela , Gumpangseth Nuttamonpat , Songhong Thanaphon , Yainoy Sakda , Monteil Arnaud , Leaungwutiwong Pornsawan , Missé Dorothée , Wichit Sineewanlaya',
        publish: 'Published: June 2023',
        year: 2023,
        book: 'Frontiers in Public Health 11; https://doi.org/10.3389/fpubh.2023.1141483',
        link: 'https://www.frontiersin.org/journals/public-health/articles/10.3389/fpubh.2023.1141483/full',
        date: '2023-06-13'
    },
    {
        topic: 'The anti-immune dengue subgenomic flaviviral RNA is present in vesicles in mosquito saliva and is associated with increased infectivity',
        author: 'Shih-Chia Yeh, Tania Strilets, Wei-Lian Tan, David Castillo, Hacène Medkour, Félix Rey-Cadilhac, Idalba M Serrato-Pomar, Florian Rachenne, Avisha Chowdhury, Vanessa Chuo, Sasha R Azar, Moirangthem Kiran Singh, Rodolphe Hamel, Dorothée Missé, R Manjunatha Kini, Linda J Kenney, Nikos Vasilakis, Marc A Marti-Renom, Guy Nir, Julien Pompon, Mariano A Garcia-Blanco',
        publish: 'Published: March 2023',
        year: 2023,
        book: 'PLoS Pathog. 2023 Mar 30;19(3):e1011224. doi: 10.1371/journal.ppat.1011224',
        link: 'https://journals.plos.org/plospathogens/article?id=10.1371/journal.ppat.1011224',
        date: '2023-03-30'
    },
    {
        topic: 'Evaluation of cutaneous immune response in a controlled human in vivo model of mosquito bites',
        author: 'David Guerrero, Hoa Thi My Vo, Chanthap Lon, Jennifer A. Bohl, Sreynik Nhik, Sophana Chea, Somnang Man, Sokunthea Sreng, Andrea R. Pacheco, Sokna Ly, Rathanak Sath, Sokchea Lay, Dorothée Missé, Rekol Huy, Rithea Leang, Hok Kry, Jesus G. Valenzuela, Fabiano Oliveira, Tineke Cantaert, Jessica E. Manning',
        publish: 'Published: November 2022',
        year: 2022,
        book: 'Nat Commun 13, 7036 (2022); https://doi.org/10.1038/s41467-022-34534-9',
        link: 'https://www.nature.com/articles/s41467-022-34534-9',
        date: '2022-11-17'
    },
    {
        topic: 'Antibody response to rabies pre-exposure vaccination among village health volunteers in a northern region of Thailand',
        author: 'Khamduang W, Hongjaisee S, Pothita T, Kongyai N, Surajinda S, Petsophonsakul W, Pornprasert S.',
        publish: 'Published: December 2021',
        year: 2021,
        book: 'Preventive veterinary medicine, 199, 105555. https://doi.org/10.1016/j.prevetmed.2021.105555',
        link: 'https://www.sciencedirect.com/science/article/abs/pii/S0167587721002993?via%3Dihub',
        date: '2021-12-02'
        
    },
    {
        topic: 'Prevalences of SARS-CoV-2 RNA and anti-SARS-CoV-2 among at-risk populations in Chiang Mai and Lamphun provinces, Thailand, during November 2020-January 2021',
        author: 'Takalay S, Ngo-Giang-Huong N, Kongnim W, Mongkolwat P, Phoseng P, Wangsaeng N, Hongjaisee S, Butr-Indr B, Tragoolpua K, Jourdain G, Pornprasert S, Khamduang W.',
        publish: 'Published: February 2022',
        year: 2022,
        book: 'PloS one, 17(2), e0263127. https://doi.org/10.1371/journal.pone.0263127',
        link: 'https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0263127',
        date: '2022-02-02'
    },
    {
        topic: 'Zika Virus Immunoglobulin G Seroprevalence among Young Adults Living with HIV or without HIV in Thailand from 1997 to 2017',
        author: 'Choyrum S, Wangsaeng N, Nechba A, Salvadori N, Saisom R, Achalapong J, Putiyanun C, Sabsanong P, Sangsawang S, Patamasingh Na Ayudhaya O, Jourdain G, Ngo-Giang-Huong N, Khamduang W.',
        publish: 'Published: February 2022',
        year: 2022,
        book: 'Viruses, 14(2), 368. https://doi.org/10.3390/v14020368',
        link: 'https://www.mdpi.com/1999-4915/14/2/368',
        date: '2022-02-10'
    },
    {
        topic: 'Human host genetics and susceptibility to ZIKV infection',
        author: 'Pauline Ferraris, Sineewanlaya Wichit, Nadège Cordel, Dorothée Missé',
        publish: 'Published: November 2021',
        year: 2021,
        book: 'Infection, Genetics and Evolution, 95, 105066; https://doi.org/10.1016/j.meegid.2021.105066',
        link: 'https://www.sciencedirect.com/science/article/pii/S1567134821003646?via%3Dihub',
        date: '2021-09-03'
    },
    {
        topic: 'Lack of Association between Adverse Pregnancy Outcomes and Zika Antibodies among Pregnant Women in Thailand between 1997 and 2015',
        author: 'Ngo-Giang-Huong N, Leroi C, Fusco D, Cressey TR, Wangsaeng N, Salvadori N, Kongyai N, Sirirungsi W, Lallemant M, Auewarakul P, Khamduang W, Jourdain G.',
        publish: 'Published: July 2021',
        year: 2021,
        book: 'Viruses, 13(8), 1423. https://doi.org/10.3390/v13081423',
        link: 'https://www.mdpi.com/1999-4915/13/8/1423',
        date: '2021-07-22' 
    },
    {
        topic: 'Soil-transmitted helminth infections in free-ranging non-human primates from Cameroon and Gabon',
        author: 'Sirima, C., Bizet, C., Hamou, H., Červená, B., Lemarcis, T., Esteban, A., Peeters, M., Mpoudi Ngole, E., Mombo, I. M., Liégeois, F., Petrželková, K. J., Boussinesq, M., & Locatelli, S.',
        publish: 'Published: July 2021',
        year: 2021,
        book: 'Parasites & vectors, 14(1), 354. https://doi.org/10.1186/s13071-021-04855-7',
        link: 'https://pubmed.ncbi.nlm.nih.gov/34225777/',
        date: '2021-07-05'
    },
    {
        topic: 'Limitations of PCR detection of filarial DNA in human stools from subjects non-infected with soil-transmitted helminths',
        author: 'Maxime P. M. Doret, Hugues C. Nana-Djeunga, Narcisse Nzune-Toche, Sébastien D. S. Pion, Cédric B. Chesnais, Michel Boussinesq, Joseph Kamgno, Emmanuelle Varlet-Marie and Sabrina Locatelli',
        publish: 'Published: May 2021',
        year: 2021,
        book: 'Parasite, 28 (2021) 47. https://doi.org/10.1051/parasite/2021046',
        link: 'https://doi.org/10.1051/parasite/2021046',
        date: '2021-05-27'
    },
    {
        topic: 'Entomological risk assessment for arbovirus transmission in zoological parks of Thailand',
        author: 'Lawwyne Lum Dau, Ronald Enrique Morales Vargas, Dora Murielle Rajonhson, Rodolphe Hamel, Patchara Phuektes, Weerapol Taweenan, Woottichai Khamduang, Phitsanu Tulayakul',
        publish: 'Published: April 2021',
        year: 2021,
        book: 'Journal of Kasetsart Veterinarians, 31(1), 1-14.',
        link: 'https://kukr.lib.ku.ac.th/kukr_es/kukr/search_detail/result/423108',
        date: '2021-04-01'
    },
    {
        topic: 'Chikungunya and Zika Viruses: Co-Circulation and the Interplay between Viral Proteins and Host Factors',
        author: 'Sineewanlaya Wichit, Nuttamonpat Gumpangseth, Rodolphe Hamel, Sakda Yainoy, Siwaret Arikit, Chuchard Punsawad, Dorothée Missé',
        publish: 'Published: April 2021',
        year: 2021,
        book: 'Pathogens 2021, 10(4), 448; https://doi.org/10.3390/pathogens10040448',
        link: 'https://www.mdpi.com/2076-0817/10/4/448',
        date: '2021-04-09'
    },
]

export default Publications